<template>
<b-container class="">
  <b-row align-h="start">
  <h1>Function generator</h1>
  </b-row>
  <b-row>
    <range-slider
      class="slider w-100"
      min="8"
      max="1024"
      step="1"
      v-model="steps">
    </range-slider> <p>Table length: {{steps}} values</p>
    </b-row>

    <b-row>
      <h5>Width </h5>
      <b-form-radio-group id="radios1"
          v-model="width"
        :options="options"></b-form-radio-group>
    </b-row>

    <b-row>
      <h5>Numbers </h5>
      <b-form-radio-group id="radios2"
          v-model="signed"
        :options="soptions"></b-form-radio-group>
    </b-row>

    <b-row>
      <h5>Function </h5>
      <b-form-radio-group id="radios3"
          v-model="funct"
        :options="foptions"></b-form-radio-group>
    </b-row>

    <b-row>
      <h5>Range </h5>
      <b-form-radio-group id="radios4"
          v-model="rng"
        :options="roptions"></b-form-radio-group>
    </b-row>

  <b-row>
  <h2>Here is the output table for ASM</h2>
  </b-row>
    <b-row>
      <div class="sourceout">{{textout}}</div>
    <b-form-textarea id="textarea2"
                     readonly
                     v-model="textout"
                     :rows="10"
                     :max-rows="15">
    </b-form-textarea>
    </b-row>
</b-container>
</template>

<script>
import RangeSlider from 'vue-range-slider'
import 'vue-range-slider/dist/vue-range-slider.css'

var grange = function (rng) {
  switch (rng) {
    case '2PI': return 2 * Math.PI;
    case 'PI': return Math.PI;
    case 'PI2': return Math.PI / 2;
  }
  return 0
}

var doSin = function (step, stepMax, rng) {
  return Math.sin(grange(rng) / stepMax * step)
}

var doCos = function (step, stepMax, rng) {
  return Math.cos(grange(rng) / stepMax * step)
}

var ftb = function (value, max, signed) {
  if (!signed) {
    value += 1; // range 0 - 2
    value *= max / 2
    return Math.floor(value)
  } else {
    value *= max / 2
    if (value < 0) value = max + 1 + value
    return Math.floor(value)
  }
}

export default {
  name: 'mathtable',
  components: {RangeSlider},
  data () {
    return {
      text: '',
      steps: 256,
      width: '8',
      options: [
        { text: 'DB (8bit)', value: '8' },
        { text: 'DW (16bit)', value: '16' }
      ],
      funct: 'sin',
      foptions: [
        { text: 'SIN', value: 'sin' },
        { text: 'COS', value: 'cos' }
      ],
      rng: '2PI',
      roptions: [
        { text: '2&pi;', value: '2PI' },
        { text: '&pi;', value: 'PI' },
        { text: '&pi;/2', value: 'PI2' }
      ],
      signed: '0',
      soptions: [
        { text: 'Unsigned', value: '0' },
        { text: 'Signed', value: '1' }
      ]
    }
  },
  computed: {
    textout: {
      get () {
        var ln = [];
        ln.push('\t; Table for ' + this.funct + '(), width ' + this.width + 'bit, ' + (this.signed === '1' ? 'signed' : 'unsigned') + ', range 0 - ' + this.rng + '\n')
        var newln = 7;
        var db = (this.width === '8') ? '\t.DB ' : '\t.DW '
        for (var i = 0; i < this.steps; i++) {
          var value;
          if (this.funct === 'sin') value = doSin(i, this.steps, this.rng);
          if (this.funct === 'cos') value = doCos(i, this.steps, this.rng);
          var trimmed = ftb(value, (this.width === '8') ? 255 : 65535, this.signed * 1)
          ln.push(((newln === 7) ? db : ', ') + trimmed + ((newln === 0) ? '\n' : ''))
          newln--;
          if (newln < 0) newln = 7
        }
        return ln.join('')
      },
      set () { return }
    }
  },
  mounted () {
    // doDrag(this)
  }
}
</script>

<style>
textarea {font-family: monospace !important;}

</style>
